import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-supervisor-course',
  templateUrl: './supervisor-course.component.html',
  styleUrls: ['./supervisor-course.component.scss']
})
export class SupervisorCourseComponent implements OnInit {
  SuperCourseForm: FormGroup;
  SuperCourseSearchForm: FormGroup;
  courseList: any[];
  filteredCourseList: any;
  userList: [];
  clgcourseData: any[] = [];
  filteredclg: any[] = [];
  filteredUserList: any;
  courseData = [];
  isShown = false;
  collegeOneList: any;
  courseOneList: any;
  isShownCourseList = false;
  isShownUserList = false;
  isShownCourseDiv = false;
  isShownUserDiv = false;
  isUserRadioBtn = false;
  isCourseRadioBtn = false;
  submitcourse = false;
  reset = false;
  submituser = false;
  // clgArr:any[];
  // courseArr:any[];
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  map = new Map<String, String>();
  usercourseList: any;
  checked: boolean;
  dialogRef: MatDialogRef<any>;
  uncheckedcourseList = [];
  checkedcourseList = [];
  uncheckedUserList = [];
  checkedUserList = [];
  SessionNo: any;
  selectUser: any;
  selectCourse: any;
  searchTerm: string = '';
  setIntervalSearch: any;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    public router: Router,
    private spinner: NgxSpinnerService,
    private modalPopupService: ModalpopService
  ) { }
  userId;
  courseId;
  UserArr: FormArray;
  CourseArr: FormArray;
  userPermission: any;
  utp: any;
  superCreate = true;
  UserCollege
  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Supervisor-Course' && element.PCreate == false) {
          this.superCreate = false;
        }
      });
    }
    this.isUserRadioBtn = true;
    this.isCourseRadioBtn = true;
    this.isShownCourseList = false;
    this.isShownUserList = false;
    this.SuperCourseForm = this.fb.group({
      user: new FormControl(''),
      course: new FormControl(''),
      UserArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      radio: new FormControl(''),
    });
    let id = {};
    // this.fetchSelectedCourseCollege(id);
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      }
    );
  }

  // getControls() {
  //   return (this.SuperCourseForm.get('UserArr') as FormArray).controls;
  // }
  // getControls1() {
  //   return (this.SuperCourseForm.get('CourseArr') as FormArray).controls;
  // }
  getControls() {
 
    if (this.searchTerm === '') {
      return (this.SuperCourseForm.get('UserArr') as FormArray).controls;
    } else {
      return (this.SuperCourseForm.get('UserArr') as FormArray).controls.filter(control =>  control.value.CoCgCgCode.toLowerCase().includes(this.searchTerm) )
    }
  }
  getControls1() {
    if (this.searchTerm === '') {
      return (this.SuperCourseForm.get('CourseArr') as FormArray).controls;
    } else {
      return (this.SuperCourseForm.get('CourseArr') as FormArray).controls.filter(control =>  control.value.CoCgCoCode.toLowerCase().includes(this.searchTerm) )
    }
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    // const newPageIndex = Math.floor(event.pageSize * event.pageIndex / this.pageSize);
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    // this.getCollegeData();
  }
  //  passed code 
  userClick() {
    this.clear();
    this.spinner.show();
    let payload = {}
    this.umsService.getUserList(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.userList = res.data;
        this.filteredUserList = this.userList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    this.isUserRadioBtn = true;
    this.isCourseRadioBtn = false;
    this.isShownUserDiv = true;
    this.isShownCourseDiv = false;
    this.isShownCourseList = false;
    this.isShownUserList = false;
    // bar.then(() => {
    //   this.addclgcourse();
    // });
  }

  courseClick() {
    this.clear();
    this.spinner.show();
    if(this.userPermission[0].CgUi == 'C'){
      this.UserCollege= this.userPermission[0].CgId;
    }
    else{
      this.UserCollege = ''
    }
 const payload = {};
    payload['CgCode'] = this.UserCollege;
    this.umsService.getCourse(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.courseList = res.data;
        this.filteredCourseList = this.courseList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
    this.isUserRadioBtn = false;
    this.isCourseRadioBtn = true;

    this.isShownUserDiv = false;
    this.isShownCourseDiv = true;

    this.isShownCourseList = false;
    this.isShownUserList = false;
  }
  // passed code endx
  selected;
  oneUserClick(e,search) {
    this.spinner.show();
    this.selected = e;
    this.selectUser = e;
    this.isShownCourseList = true;
    this.isShownUserList = false;
    this.submitcourse = true;
    this.submituser = false;
    this.reset = true;
    this.uncheckedcourseList = [];
    this.checkedcourseList = [];
    let payload = {};
    this.userId = e;
    payload['SearchString'] = search;
    this.umsService.getCourse(payload).subscribe((allres) => {
      this.spinner.hide();
      if (allres.data.length > 0) {
        let allcourseList = [];
        allcourseList = allres.data;

        const userFetchPayload = {};
        userFetchPayload['SuOpid'] = e;
        userFetchPayload['SuCoCode'] = '';
        this.umsService.getUserCourse(userFetchPayload).subscribe((res) => {
          this.usercourseList = res.data;
          this.spinner.hide();
          this.SuperCourseForm = this.fb.group({
            user: new FormControl(e),
            course: new FormControl(''),
            UserArr: this.fb.array([]),
            CourseArr: this.fb.array([]),
          });
          if (allcourseList !== undefined) {
            this.CourseArr = this.SuperCourseForm.get('CourseArr') as FormArray;
            allcourseList.map((element, i) => {
              element['checked'] = false;
              this.usercourseList.forEach((elementA) => {
                if (
                  element.CoCode == elementA.SuCoCode &&
                  e == elementA.SuOpid
                ) {
                  element['checked'] = true;
                }
              });
            });
            allcourseList.forEach((element) => {
              this.CourseArr.push(
                this.fb.group({
                  clgcoursecheckbox: new FormControl(element.checked),
                  CoCgCoCode: new FormControl(element.CoName),
                  SuCoCode: new FormControl(element.CoCode),
                  SuOpid: new FormControl(e),
                  CoCgCgName: new FormControl(element.CgName),
                  toggle: false,
                })
              );
              if (element.checked == false) {
                this.uncheckedcourseList.push(element);
              } else {
                this.checkedcourseList.push(element);
              }
            });
          }
        });
      } else {
      }
    });
  }

  oneCourseClick(e,search) {
    this.spinner.show();
    this.selected = e;
    this.selectCourse = e;
    this.uncheckedUserList = [];
    this.checkedUserList = [];
    this.isShownCourseList = false;
    this.isShownUserList = true;
    this.submitcourse = false;
    this.submituser = true;
    this.reset = true
    let payload = {};
    this.userId = e;
    payload['SearchString'] = search;
    this.umsService.getUserList(payload).subscribe((allResCollege) => {
      this.spinner.hide();
      if (allResCollege.data.length > 0) {
        let allUserList = [];
        allUserList = allResCollege.data;
        const courseFetchPayload = {};
        courseFetchPayload['SuOpid'] = '';
        courseFetchPayload['SuCoCode'] = e;
        this.umsService.getUserCourse(courseFetchPayload).subscribe((res) => {
          this.usercourseList = res.data;
          this.spinner.hide();
          this.SuperCourseForm = this.fb.group({
            user: new FormControl(''),
            course: new FormControl(e),
            UserArr: this.fb.array([]),
            CourseArr: this.fb.array([]),
          });
          if (allUserList !== undefined) {
            this.UserArr = this.SuperCourseForm.get('UserArr') as FormArray;
            allUserList.map((element, i) => {
              element['checked'] = false;
              this.usercourseList.forEach((elementA) => {
                if (
                  element.LoginId == elementA.SuOpid &&
                  e == elementA.SuCoCode
                ) {
                  element['checked'] = true;
                }
              });
            });
            allUserList.forEach((element) => {
              this.UserArr.push(
                this.fb.group({
                  clgcoursecheckbox: new FormControl(element.checked),
                  CoCgCgName: new FormControl(''),
                  SuOpid: new FormControl(element.LoginId),
                  SuCoCode: new FormControl(e),
                  CoCgCgCode: new FormControl(element.LoginFullName),
                  toggle: false,
                })
              );
              if (element.checked == false) {
                this.uncheckedUserList.push(element);
              } else {
                this.checkedUserList.push(element);
              }
            });
          }
        });
      } else {
      }
    });
  }

  clear() {
    this.SuperCourseForm = this.fb.group({
      user: new FormControl(''),
      course: new FormControl(''),
      UserArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
    });
  }

  removeCourseArr(i) {
    this.CourseArr.removeAt(i);
  }

  removeCollegeArr(i) {
    this.CourseArr.removeAt(i);
  }

  // fetchUser() {
  //   const payload = {};

  //   this.umsService.getUserList(payload).subscribe((res) => {
  //     if (res.status) {
  //       this.userList = res.data;
  //       this.filteredUserList = this.userList.slice();
  //     } else {
  //       // this.apimicroservice.openSnackbar(res.message);
  //     }
  //   });
  // }

  submit() {
    this.addclgcourse();
  }

  submit1() {
    this.addclgcourse1();
  }

  addclgcourse() {
    let payload = this.SuperCourseForm.value;
    payload['CourseArr'].forEach((element, i) => {
      if (element.clgcoursecheckbox == true) {
        this.uncheckedcourseList.forEach(elementA => {
          if (element.SuCoCode == elementA.CoCode) {
            let xxxx = {};
            xxxx['SuOpid'] = element.SuOpid;
            xxxx['SuCoCode'] = element.SuCoCode;
            this.umsService.AddUserCourse(xxxx).subscribe((res) => {
              this.spinner.hide();
            });
          }
        });
      }
      if (element.clgcoursecheckbox == false) {
        this.checkedcourseList.forEach(elementA => {
          if (element.SuCoCode == elementA.CoCode) {
            this.slideToggleChange(element, 'course');
          }
        });
      }
    });

    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.oneUserClick(this.selected,'')
      this.searchTerm = ''
    });
  }

  addclgcourse1() {
    let payload = this.SuperCourseForm.value;
    payload['UserArr'].forEach((element, i) => {
      if (element.clgcoursecheckbox == true) {
        this.uncheckedUserList.forEach(elementA => {
          if (element.SuOpid == elementA.LoginId) {
            let xxxx = {};
            xxxx['SuOpid'] = element.SuOpid;
            xxxx['SuCoCode'] = element.SuCoCode;
            this.umsService.AddUserCourse(xxxx).subscribe((res) => {
            });
          }
        });
      }
      if (element.clgcoursecheckbox == false) {
        this.checkedUserList.forEach(elementA => {
          if (element.SuOpid == elementA.LoginId) {
            this.slideToggleChange(element, 'user');
          }
        });
      }
    });
    let data = {};
    data['message'] = "Submitted Successfully";
    data['title'] = 'Information';
    data['icon'] = 'fas fa-check';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      this.oneCourseClick(this.selected,'')
      this.searchTerm = ''
    });
  }

  freshCourseCollageMapping(allrecord, cgcode) {
    let data = allrecord.data;
    this.SuperCourseForm = this.fb.group({
      user: new FormControl(''),
      course: new FormControl(''),
      UserArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
    });
    this.userList = data.CourseArr;
    if (data !== undefined) {
      data.map((element, i) => {
        this.CourseArr = this.SuperCourseForm.get('CourseArr') as FormArray;
        this.CourseArr.push(
          this.fb.group({
            clgcoursecheckbox: new FormControl(false),
            CoCgCoCode: new FormControl(element.CoName),
            CoCode: new FormControl(element.CoCode),
            CoCgCgCode: new FormControl(cgcode),
            CoCgCgName: new FormControl(element.CgName),
            toggle: false,
          })
        );
      });
    }
  }

  fetchSelectedCourseCollege(id) {
    this.userId = id;
    const payload = {};
    payload['CgCode'] = id;
    payload['CoCode'] = '';
    this.umsService.getCollegeCourse(payload).subscribe((res) => {
      if (res.status) {
        this.usercourseList = res.data;
      }
    });
  }


  slideToggleChange(e, type) {
    if (type == 'course') {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          SuOpid: e.SuOpid,
          SuCoCode: e.SuCoCode,
        },
      };
      this.httpClient
        .delete(environment.serviceUrl + '/admin/userToCourse', options)
        .subscribe(
          (s) => { },
          (ERROR: HttpErrorResponse) => { }
        );
    } else if (type == 'user') {
      const options = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
        body: {
          SuOpid: e.SuOpid,
          SuCoCode: e.SuCoCode,
        },
      };
      this.httpClient
        .delete(environment.serviceUrl + '/admin/userToCourse', options)
        .subscribe(
          (s) => { },
          (ERROR: HttpErrorResponse) => { }
        );
    }
  }

  back() {
    // this.SuperCourseForm.reset();
    // window.location.reload();
    this.isShownCourseList = false;
    this.isShownCourseList = false;
    this.isShownUserDiv = false;
    this.isShownCourseDiv = false;
    this.isShownUserList = false;
    this.submitcourse = false;
    this.submituser = false;
    this.reset = false;
    this.SuperCourseForm = this.fb.group({
      user: new FormControl(''),
      course: new FormControl(''),
      UserArr: this.fb.array([]),
      CourseArr: this.fb.array([]),
      radio: new FormControl(''),
    });
    this.UserArr.clear();
    this.CourseArr.clear();
  }

  print(){
    let submitpayload = this.SuperCourseForm.value;
    let payload1 = {}
    payload1['MenuName'] = 'SupervisorCourse';
    payload1['CallMode'] = 'C';
    payload1['ByOp'] = 'Y'
    let jsonString = JSON.stringify(payload1)
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 120,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId":  '',
      "CsNo": '',
      "PgBreak": '',
      "StrId": '',
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '',
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  // applyFilter(event: any){
  //   let search = event.target.value;
   
  //   if(this.submituser == true){
  //     this.oneCourseClick(this.selectCourse,search)
  //   }
  //   else if(this.submitcourse == true){
  //     this. oneUserClick(this.selectUser,search)
  //   }
    
  // }
  applyFilter(event: any){
    let search = event.target.value;
    this.searchTerm = search.toLowerCase();
  }

  keypress() {

    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.courseList = [];
      // this.userList = [];
      const payload = {};
      payload['PageSize'] = this.pageSize;
      payload['PageNumber'] = this.currentPage;
      payload['SearchString'] = this.SuperCourseSearchForm.value;
      this.umsService.getCourse(payload).subscribe(res => {
        this.filteredCourseList = res.data;
        // this.filteredUserList = res.data;
        this.totalItems = res.data[0].TotalRecords;
      }, (ERROR: HttpErrorResponse) => {
        this.courseList = [];
      });
    },1000)
    

  }
}
// addUserCourse